import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Hero = () => {
	const { t } = useTranslation();
	return (
		<section className='bg-section md:pt-6'>
			<div className='flex flex-col pt-10 px-5 pb-16 md:pt-0 md:flex-row   items-center justify-between space-y-8  	max-w-screen-xl m-auto'>
				<div className='space-y-3 w-full lg:w-1/2 order-2 md:order-1 '>
					<h1 className='text-4xl md:text-5xl lg:text-7xl font-bold text-gray-700'>
						{t('Herotitle')}
						<br /> {t('subtitle')}
					</h1>
					<p className='text-xl md:text-2xl text-gray-800'>
						<span className='w-2  bg-secondary me-2 text-secondary '>|</span>
						{t('Hero description')}
					</p>

					<NavLink
						to='/courses'
						className='block py-2 '>
						<button className='bg-secondary text-white rounded-full text-lg md:text-xl px-7 py-2 font-bold'>
							{t('getStarted')}
						</button>
					</NavLink>
				</div>
				<div className='lg:w-1/2  w-full pb-10 md:pb-0  order-1 md:order-2'>
					<img
						loading='lazy'
						src={'/images/home_hero_image.webp'}
						alt='main page img'
					/>
				</div>
			</div>
		</section>
	);
};

export default Hero;
